// extracted by mini-css-extract-plugin
module.exports = {"ChipIcon":"Chip_ChipIcon__8ytm_","Chip":"Chip_Chip__3oQuU","clickable":"Chip_clickable__2zcGy"};